
















import axios from "axios";
import Vue, { PropType } from "vue";
import { OrgAccess } from "@/types/REST-API-DOMAIN/OrgAccess";
import { bus } from "@/main";

interface State {
  orgAccesses: Array<OrgAccess> | null;
  selectedOrg: OrgAccess | null;
}

export default Vue.extend({
  name: "OrganizationSelect",
  props: {
    hideIfSingleAccess: { type: Boolean },
    providedOrgAccesses: Array as PropType<Array<OrgAccess>>
  },
  data: (): State => {
    return {
      orgAccesses: null,
      selectedOrg: null
    };
  },
  mounted(): void {
    if (this.providedOrgAccesses) {
      this.selectedOrg = this.providedOrgAccesses[0];
      if (this.$route.query.orgId) {
        const access = this.providedOrgAccesses.find(
          (oa: OrgAccess) => oa.orgId === this.$route.query.orgId
        );
        this.selectedOrg = access ? access : this.selectedOrg;
      }
    } else {
      this.getOrgAccess();
    }
  },
  methods: {
    async getOrgAccess() {
      bus.$emit("loadingOn", "Loading...");
      const resp = await axios.get("/rest-api/organization/access/billing");
      this.orgAccesses = resp.data;
      if (this.$route.query.orgId) {
        this.selectedOrg = resp.data.find(
          (oa: OrgAccess) => oa.orgId === this.$route.query.orgId
        );
      }
      if (!this.selectedOrg) {
        this.selectedOrg = resp.data[0];
      }
      this.sendChange();
      bus.$emit("loadingOff");
    },
    sendChange() {
      this.$emit("org-change", this.selectedOrg);
    }
  },
  computed: {
    getOrgAccesses(): Array<OrgAccess> {
      if (this.providedOrgAccesses) {
        return this.providedOrgAccesses;
      } else {
        return this.orgAccesses ? this.orgAccesses : [];
      }
    }
  },
  watch: {
    providedOrgAccesses() {
      if (this.$route.query.orgId) {
        const access = this.providedOrgAccesses.find(
          (oa: OrgAccess) => oa.orgId === this.$route.query.orgId
        );
        this.selectedOrg = access ? access : this.selectedOrg;
      } else {
        this.selectedOrg = this.providedOrgAccesses[0];
      }
    }
  }
});
